import type { ReactNode } from 'react';
import { cx } from '../cx';
import { Avatar } from '../Avatar/Avatar';

export type BylineProps = {
  author: { name: string; href?: string; avatarSrc?: string | null; role?: ReactNode };
  /** "Updated 11 Oct 2026", formatted by the caller. */
  updated?: ReactNode;
  /** Machine-readable date for <time>. */
  updatedDateTime?: string;
  /** More context, e.g. the data cut-off of a research piece. */
  extra?: ReactNode;
  className?: string;
};

/** Who wrote a piece and when it was last updated (articles, research). */
export function Byline({ author, updated, updatedDateTime, extra, className }: BylineProps) {
  const name = author.href ? (
    <a
      href={author.href}
      rel="author"
      className="rounded-jc-info font-semibold text-jc-ink hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jc-focus"
    >
      {author.name}
    </a>
  ) : (
    <span className="font-semibold text-jc-ink">{author.name}</span>
  );
  return (
    <div className={cx('flex items-center gap-3 text-sm text-jc-ink-secondary', className)}>
      <Avatar name={author.name} src={author.avatarSrc} />
      <div className="flex min-w-0 flex-col">
        <span>
          {name}
          {author.role ? <span className="text-jc-ink-secondary"> · {author.role}</span> : null}
        </span>
        <span className="text-xs text-jc-ink-secondary">
          {updated ? <time dateTime={updatedDateTime}>{updated}</time> : null}
          {updated && extra ? ' · ' : null}
          {extra}
        </span>
      </div>
    </div>
  );
}
